"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdinalNFT = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-useless-escape */
const scrypt_ts_1 = require("scrypt-ts");
const ordinal_1 = require("./ordinal");
const _1satApis_1 = require("../1satApis");
const contentType_1 = require("../contentType");
class OrdinalNFT extends scrypt_ts_1.SmartContract {
    constructor() {
        super();
        this.isOneSatNFT = true;
    }
    buildStateOutputNFT() {
        const stateScript = ordinal_1.Ordinal.removeInsciption(this.getStateScript());
        return scrypt_ts_1.Utils.buildOutput(stateScript, 1n);
    }
    static buildInscribedOutput(script, content, contentType) {
        const part1 = ordinal_1.Ordinal.createInsciption(content, contentType);
        const part2 = ordinal_1.Ordinal.removeInsciption(script);
        return scrypt_ts_1.Utils.buildOutput(part1 + part2, 1n);
    }
    async inscribe(inscription) {
        this.prependNOPScript(ordinal_1.Ordinal.create(inscription));
        return this.deploy(1);
    }
    async inscribeText(text) {
        return this.inscribe({
            content: text,
            contentType: contentType_1.ContentType.TEXT,
        });
    }
    /**
     *
     * @param content in base64 string format or buffer
     * @param contentType
     * @returns
     */
    async inscribeImage(content, contentType) {
        return this.inscribe({
            content: content instanceof Buffer
                ? content
                : Buffer.from(content, 'base64'),
            contentType,
        });
    }
    getInscription() {
        const nopScript = this.getPrependNOPScript();
        if (nopScript) {
            return ordinal_1.Ordinal.getInscription(nopScript);
        }
        return null;
    }
    getDefaultTxBuilder(methodName) {
        return async function (current, options, ...args) {
            // bsv change address
            const changeAddress = await current.signer.getDefaultAddress();
            const nexts = [];
            const tx = new scrypt_ts_1.bsv.Transaction();
            tx.addInput(current.buildContractInput());
            const recipient = options.transfer;
            if (recipient) {
                if (!(recipient instanceof scrypt_ts_1.SmartContract)) {
                    throw new Error('Transfer option must be of type `SmartContract`.');
                }
                tx.addOutput(new scrypt_ts_1.bsv.Transaction.Output({
                    script: recipient.lockingScript,
                    satoshis: 1,
                }));
                nexts.push({
                    instance: recipient,
                    balance: 1,
                    atOutputIndex: nexts.length,
                });
            }
            else {
                throw new Error('No NFTReceiver found!');
            }
            const feePerKb = await current.provider?.getFeePerKb();
            tx.feePerKb(feePerKb);
            tx.change(changeAddress);
            if (options.sequence !== undefined) {
                tx.setInputSequence(0, options.sequence);
            }
            if (options.lockTime) {
                const _sequence = options.sequence !== undefined
                    ? options.sequence
                    : 0xfffffffe;
                tx.setInputSequence(0, _sequence); // activate locktime interlock
                tx.setLockTime(options.lockTime);
            }
            return Promise.resolve({
                tx,
                atInputIndex: 0,
                nexts: nexts,
            });
        };
    }
    static fromUTXO(utxo) {
        if (utxo.satoshis !== 1) {
            throw new Error('invalid ordinal p2pkh utxo');
        }
        const ins = ordinal_1.Ordinal.getInsciptionScript(utxo.script);
        const instance = this.fromLockingScript(utxo.script, {}, scrypt_ts_1.bsv.Script.fromHex(ins));
        instance.from = utxo;
        return instance;
    }
    static async getLatestInstance(origin, network) {
        const utxo = await _1satApis_1.OneSatApis.fetchLatestByOrigin(origin, network);
        if (utxo === null) {
            throw new Error('no utxo found');
        }
        const a = this.fromUTXO(utxo);
        return a;
    }
    /**
     * recover a `OrdinalNFT` instance from the transaction
     * if the contract contains onchain properties of type `HashedMap` or `HashedSet`
     * it's required to pass all their offchain raw data at this transaction moment
     * @param tx transaction
     * @param atOutputIndex output index of `tx`
     * @param offchainValues the value of offchain properties, the raw data of onchain `HashedMap` and `HashedSet` properties, at this transaction moment
     */
    static fromTx(tx, atOutputIndex, offchainValues) {
        const outputScript = tx.outputs[atOutputIndex].script;
        const nopScript = ordinal_1.Ordinal.nopScriptFromScript(outputScript);
        const instance = super.fromTx(tx, atOutputIndex, offchainValues, nopScript);
        return instance;
    }
}
exports.OrdinalNFT = OrdinalNFT;
__decorate([
    (0, scrypt_ts_1.prop)(true)
], OrdinalNFT.prototype, "isOneSatNFT", void 0);
__decorate([
    (0, scrypt_ts_1.method)()
], OrdinalNFT.prototype, "buildStateOutputNFT", null);
__decorate([
    (0, scrypt_ts_1.method)()
], OrdinalNFT, "buildInscribedOutput", null);
